export const stringEquals = (
  left: string | undefined,
  right: string | undefined
) => {
  const sLeft = left?.trim().toLocaleLowerCase();
  const sRight = right?.trim().toLocaleLowerCase();
  return sLeft === sRight;
};

export const Validators = {
  isNotOneOfStrings: (set: string[] | undefined) => (v: string) =>
    !set?.find((x) => stringEquals(x, v)) || `Entry ${v} is already taken`,
  requiredEntity: (v: number | undefined) => v || `A selection is required`,
};
